module.exports = __webpack_public_path__ + "img/noData.0ff11684.png";